import { DOB, email, required, Spacer } from '@jfs/ui-new'
import { TextInputNew } from '../../../../components/AdminInputs'
import { styles } from '../../styles'

export const accountSummaryForm = (isEditMode: boolean) => [
  {
    actionTitle: 'Proceed',
    key: 'accountSummary',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'gender',
            ComponentName: TextInputNew,
            label: 'Gender',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'gender',
          },
          {
            fieldName: 'firstName',
            ComponentName: TextInputNew,
            label: 'First Name',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'firstName',
          },
          {
            fieldName: 'lastName',
            ComponentName: TextInputNew,
            label: 'Last Name',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'lastName',
          },
          {
            fieldName: 'dob',
            ComponentName: TextInputNew,
            label: 'DOB (DD-MM-YYYY) (Optional)',
            placeholder: '',
            editable: isEditMode,
            maxLength: 10,
            validationSchema: isEditMode ? DOB : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'dob',
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'businessDisplayName',
            ComponentName: TextInputNew,
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            placeholder: '',
            label: 'Business Display Name',
            testID: 'businessDisplayName',
          },
          {
            fieldName: 'entityPanNumber',
            ComponentName: TextInputNew,
            label: 'Entity PAN Number',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'entityPanNumber',
          },
          {
            fieldName: 'businessChannel',
            ComponentName: TextInputNew,
            label: 'Business Channel',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'businessChannel',
          },
          {
            fieldName: 'businessLine',
            ComponentName: TextInputNew,
            label: 'Line Of Business',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'businessLine',
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'status',
            ComponentName: TextInputNew,
            label: 'Status',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'status',
          },
          {
            fieldName: 'mobileNumber',
            ComponentName: TextInputNew,
            label: 'Mobile Number',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'mobileNumber',
          },
          {
            fieldName: 'emailId',
            ComponentName: TextInputNew,
            label: 'Email ID',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? email : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'emailId',
          },
          {
            fieldName: 'webAddress',
            ComponentName: TextInputNew,
            label: 'Web Address',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'webAddress',
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'addressLine1',
            ComponentName: TextInputNew,
            label: 'Address 1 (Optional)',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'addressLine1',
          },
          {
            fieldName: 'addressLine2',
            ComponentName: TextInputNew,
            label: 'Address 2 (Optional)',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'addressLine2',
          },
          {
            fieldName: 'city',
            ComponentName: TextInputNew,
            label: 'City (Optional)',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'city',
          },
          {
            fieldName: 'state',
            ComponentName: TextInputNew,
            label: 'State/UT (Optional)',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'state',
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'pincode',
            ComponentName: TextInputNew,
            label: 'Pincode (Optional)',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'pincode',
          },
          {
            fieldName: 'country',
            ComponentName: TextInputNew,
            label: 'Country',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'country',
          },
          {
            fieldName: 'storeCode',
            ComponentName: TextInputNew,
            label: 'Store Code',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'storeCode',
          },
          {
            fieldName: 'format',
            ComponentName: TextInputNew,
            label: 'Format',
            placeholder: '',
            editable: isEditMode,
            validationSchema: isEditMode ? required : undefined,
            ...styles.textinputStyle(isEditMode),
            testID: 'format',
          },
          { fieldName: 'spacer2', ComponentName: Spacer },
          { fieldName: 'spacer2', ComponentName: Spacer },
        ],
        horizontalSpacing: 8,
      },
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]
